<template>
  <div class="kontrollerStatusOneComp">
    <tbl-one-comp :rows="kontrollerTbl"/>
  </div>
</template>

<script>
export default {
  name: 'kontrollerStatusOneComp',
  props: {
    params: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      moduleName: 'kontrollers',
      required: [
        'KID',
        'rating',
        'BASUM',
        'BAKUP',
        'BAS',
        'BAPP',
        'USSD',
        'GSMSL',
        'FWVER',
        // 'KK',
        'K1S',
        // 'K2S',
        'k1t',
        // 'k2t',
        // 'CTIME',
        // 'CLS',
        // 'HUM',
        // 'CM',
        'TBM',
        'RBM',
        'LM'
        // 'SS',
        // 'SMSTIME',
        // 'LC'
      ]
    }
  },
  created: function () {
    // this.$store.dispatch(`${this.moduleName}/getOne`, {params: this.params, required: this.required});
  },
  components: {
  },
  computed: {
    kontroller: function () { return this.$store.getters[`${this.moduleName}/getOne`] },
    kontrollerTbl: function () {
      let model = this.$store.getters[`${this.moduleName}/getOne`]
      return this.$helpers.mapper.modelRequired(this.required, model)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
